import React from "react";

import { Box, Divider } from "@chakra-ui/react";
import { useParams } from "react-router-dom";

import { Inspeccion } from "components/Portfolio/Lista/Inspeccion";
import { Localizacion } from "components/Portfolio/Lista/Localizacion";
import { Tipologia } from "components/Portfolio/Lista/Tipologia";
import { getIteListThunk } from "store/ITE/thunks";
import { getComunicacionesPendientesThunk, getInfoActivosThunk, getPortfolioStatsThunk } from "store/portfolio/thunks";
import { useAppDispatch, useAppSelector } from "store/store";

import { Accesibilidad } from "./Accesibilidad";
import { Certificacion } from "./Certificacion";
import { FiltersApplied } from "./components/FiltersApplied";
import { MiddleSection } from "./components/MiddleSection";
import { Comunicaciones } from "./Comunicaciones";
import { Conservacion } from "./Conservacion";
import { Energetica } from "./Energetica";
import { Normativa } from "./Normativa";

export const PortfolioList: React.FC = () => {
	const { portfolioParams } = useParams();
	const filterSelection = useAppSelector((state) => state.portfolio.filterSelection);
	const orderBy = useAppSelector((state) => state.portfolio.orderBy);
	const page = useAppSelector((state) => state.portfolio.page);

	const dispatch = useAppDispatch();

	const tipoIte = React.useMemo(() => {
		return undefined;
	}, [portfolioParams]);

	const RenderTable = () => {
		const getView = (portfolioParams: string | undefined) => {
			switch (portfolioParams) {
				case "inspeccion":
					return <Inspeccion />;
				case "localizacion":
					return <Localizacion />;
				case "tipologia":
					return <Tipologia />;
				case "nec":
					return <Conservacion />;
				case "nee":
					return <Energetica />;
				case "nae":
					return <Accesibilidad />;
				case "ncn":
					return <Normativa />;
				case "certificacion":
					return <Certificacion />;
				case "certificacion-basicas":
					return <Certificacion />;
				case "comunicaciones":
					return <Comunicaciones />;
				default:
					return <Inspeccion />;
			}
		};
		return getView(portfolioParams);
	};

	React.useEffect(() => {
		if (filterSelection !== null && orderBy === null) {
			dispatch(getInfoActivosThunk({ filterSelection, page, tipoIte, view: portfolioParams }));
			dispatch(getPortfolioStatsThunk({ filterSelection, tipoIte, view: portfolioParams }));
		}
		if (filterSelection !== null && orderBy !== null) {
			dispatch(
				getInfoActivosThunk({
					filterSelection,
					order: `${orderBy.column}.${orderBy.direction}`,
					page,
					tipoIte,
					view: portfolioParams,
				}),
			);
			dispatch(getPortfolioStatsThunk({ filterSelection, tipoIte, view: portfolioParams }));
		}
		if (orderBy !== null && filterSelection === null) {
			dispatch(
				getInfoActivosThunk({ order: `${orderBy.column}.${orderBy.direction}`, page, tipoIte, view: portfolioParams }),
			);
			dispatch(getPortfolioStatsThunk({ tipoIte, view: portfolioParams }));
		}
		if (orderBy === null && filterSelection === null) {
			dispatch(getInfoActivosThunk({ page, tipoIte, view: portfolioParams }));
			dispatch(getPortfolioStatsThunk({ tipoIte, view: portfolioParams }));
		}
	}, [filterSelection, orderBy, page, portfolioParams]);

	React.useEffect(() => {
		dispatch(getIteListThunk({}));
		dispatch(getComunicacionesPendientesThunk());
	}, []);

	return (
		<Box mt="1.5rem">
			<MiddleSection />
			<FiltersApplied />
			<Divider mb="1.5rem" />
			<RenderTable />
		</Box>
	);
};
